import './_styles.scss';
import React, { StatelessComponent } from 'react';
import {
    PLAY_LIST_CONTAINER,
    PLAY_LIST_HEADER,
    PLAY_LIST_BODY,
    PLAY_LIST_ITEM,
    BUTTON_NO_TEXT_TRANSFORMATION
} from '../utils/constants';
import { Button } from '../Button';

export interface IPlayListItem {
    phonogramId: number;
    title: string;
    artist: string;
    album: string;
    duration: string;
    url: string;
    songIndex?: number;
    type?: string;
}

export interface IPlayListVolume {
    name: string;
    songs: IPlayListItem[];
}

export interface IPlayListProps {
    headerText: string[];
    items: IPlayListItem[];
    onClick?: (item: IPlayListItem) => void;
    onBlur?: (item: IPlayListItem) => void;
    onFocus?: (item: IPlayListItem) => void;
}

export const PlayList: StatelessComponent<IPlayListProps> = props => {
    const { headerText, items, onBlur, onClick, onFocus } = props;

    const getColumn = (index: number, columnText: string): React.ReactNode => {
        if (index === 0) {
            return (
                <span>
                    <i className="fa fa-play nonDisplay" aria-hidden="true" />
                    {columnText}
                </span>
            );
        }

        return <span>{columnText}</span>;
    };

    const getList = (songInfo: string[], id: string): React.ReactChild => {
        return (
            <div className="song" id={`song-${id}`}>
                {songInfo.map((columnText, index) => {
                    return <div className="column">{getColumn(index, columnText)}</div>;
                })}
            </div>
        );
    };

    const onClickButton = (song: IPlayListItem): void => {
        if (typeof onClick === 'function') {
            onClick(song);
        }
    };

    const onBlurButton = (song: IPlayListItem): void => {
        if (typeof onBlur === 'function') {
            onBlur(song);
        }
    };

    const onFocusButton = (song: IPlayListItem): void => {
        if (typeof onFocus === 'function') {
            onFocus(song);
        }
    };

    const getHeader = (): React.ReactNode => {
        return (
            <div className={PLAY_LIST_HEADER}>
                {headerText.map(head => {
                    return <div className="column">{head}</div>;
                })}
            </div>
        );
    };

    const getSongs = (songs: IPlayListItem[]): React.ReactElement[] => {
        return songs.map((song, songIndex) => {
            const playlistSong: IPlayListItem = {
                phonogramId: song.phonogramId,
                title: song.title,
                artist: song.artist,
                album: song.album,
                duration: song.duration,
                url: song.url,
                songIndex,
                type: 'song'
            };
            return (
                <Button
                    type="button"
                    variant="info"
                    className={`${PLAY_LIST_ITEM} focusable ${BUTTON_NO_TEXT_TRANSFORMATION}`}
                    onClick={(): void => {
                        onClickButton(playlistSong);
                    }}
                    onBlur={(): void => {
                        onBlurButton(playlistSong);
                    }}
                    onFocus={(): void => {
                        onFocusButton(playlistSong);
                    }}
                >
                    {getList(
                        [`${songIndex + 1}. ${song.title}`, song.artist, song.album, song.duration],
                        song.phonogramId.toString()
                    )}
                </Button>
            );
        });
    };

    return (
        <div className={PLAY_LIST_CONTAINER}>
            <div className={PLAY_LIST_BODY}>
                {getHeader()}
                {getSongs(items)}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/PlayList/index.tsx